<template>
    <span :class="style"> {{timeLeftDisplay}} </span>
</template>

<script>
export default {
	data() {
		return {
			timeLeftDisplay: "",
            style: "default",
            countdown: null
        }
    },
	computed: {
		expiredText() {
			return this.params.expiredTextGetter
				? this.params.expiredTextGetter(this.params.data)
				: this.params.expiredText || this.$t("common.countdown.expired");
		},
		endTime() {
			return this.params.endTimeGetter
				? this.params.endTimeGetter(this.params.data)
				: this.params.data[this.params.endTimeField || this.params.colDef.field];
		}
	},
    beforeMount() {
		if (!this.endTime) {
			return;
		}

		let endTime = moment(this.endTime);

		let isExpired = this.updateTimeLeft(endTime);
		if (!isExpired) {
			this.startCountdown(endTime);
		} else {
			this.callExpiredCallback();
		}
    },
    destroyed() {
		this.stopCountdown();
	},
	methods: {
		startCountdown(endTime) {
			this.countdown = setInterval(() => {
				let isExpired = this.updateTimeLeft(endTime);
				if (isExpired) {
					this.stopCountdown();
					this.callExpiredCallback();
				}
			}, 1000);
        },
        stopCountdown() {
			clearInterval(this.countdown);
        },
        updateTimeLeft(endTime) {
			let now = moment();
			let duration = moment.duration(endTime.diff(now));

			if (duration.days() > 0) {
				this.timeLeftDisplay = this.$t("common.countdown.moreThanOneDay", {
					days: duration.days(),
					hours: duration.hours()
				});
				this.style = "default";
			} else if (duration.hours() > 0) {
				this.timeLeftDisplay = this.$t("common.countdown.moreThanOneHour", {
					hours: duration.hours(),
					minutes: duration.minutes()
				});
				this.style = "default";
			} else if (duration.minutes() > 1) {
				this.timeLeftDisplay = this.$t("common.countdown.moreThanOneMinute", {
					minutes: duration.minutes(),
					seconds: duration.seconds()
				});
				this.style = "default";
			} else {
				this.timeLeftDisplay = this.$t("common.countdown.lessThanOneMinute");
				this.style = "nearlyExpired";
			}

			let isExpired = duration.asSeconds() <= 0;
			if (isExpired) {
				this.timeLeftDisplay = this.expiredText;
				this.style = "expired";
			}

			return isExpired;
        },
		callExpiredCallback() {
			if (this.params.onExpire) {
				this.params.onExpire(this.params.data);
			}
		}
    }
};
</script>

<style lang="scss">
    .default {}

    .nearlyExpired {
        color: red;
    }

    .expired {
        color: red;
    }
</style>
